import { Component } from '@angular/core';

@Component({
  selector: 'app-work-location-create',
  standalone: false,
  templateUrl: './work-location-create.component.html',
  styleUrl: './work-location-create.component.scss',
})
export class WorkLocationCreateComponent {}
